const colors = {
  green: '#1B998B',
  blue: '#4B8FF0',
  red: '#d32f2f',
  green03: 'rgba(27, 153, 139, 0.3)',
  green05: 'rgba(27, 153, 139, 0.5)',
  green08: 'rgba(27, 153, 139, 0.8)',
  dark: '#343434',
  dark003: 'rgba(52, 52, 52, 0.03)',
  dark005: 'rgba(52, 52, 52, 0.05)',
  dark01: 'rgba(52, 52, 52, 0.1)',
  dark03: 'rgba(52, 52, 52, 0.3)',
  dark04: 'rgba(52, 52, 52, 0.4)',
  dark05: 'rgba(52, 52, 52, 0.5)',
  dark07: 'rgba(52, 52, 52, 0.7)',
  dark08: 'rgba(52, 52, 52, 0.8)',

  // nowe fonty
  white: '#ffffff',

  green900:'#188F82',
  green700:'#188F82',
  green500:'#1B998B',
  green400:'#7FD7CD',
  green300:'#E7F1F0',

  gray700:'#5E5E5E',
  gray500:'#848484',
  gray400:'#ABABAB',
  gray300:'#CBCBCB',
  gray200:'#ECEBEA',
  gray100:'#F9F8F8',

  black900:'#111110',
  black700:'#4D4D4A',
  black500:'#6B6B68',

};

export default colors;
